<!-- 论文指导记录 -->
<template>
  <svg
    t="1748247003680"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="40471"
    width="200"
    height="200"
  >
    <path
      d="M667.9 912.2c-15.8 0.4-28.4 13.2-28.4 29.1 0 16 13 29 29.1 29H764c15.8-0.3 28.4-13.2 28.4-29 0-16-13-29.1-29.1-29.1h-95.4zM732.5 515.1c-2.9-15.8-18.1-26.2-34-23.2-63.9 11.9-96.1 56-99.8 123.1-0.9 16 11.4 29.7 27.4 30.6 16 0.9 29.7-11.4 30.7-27.4 2.3-42.2 17.2-62.7 52.3-69.2l0.7-0.2c15.6-3.2 25.6-18.2 22.7-33.7z m-16.2-117.7c-120.5 0-218.1 98-218.1 218.9 0 76 38.6 142.9 97.1 182.1 0.4 0.3 2.4 16.3 5.8 47.9l0.1 0.9c3.6 29.1 28.3 50.9 57.7 50.9h114.3c29.2-0.5 53.6-22.5 56.9-51.6 2.8-24.8 4.7-40.2 5.9-46.3l0.2-1.2c59.2-39.2 98.2-106.5 98.2-182.9 0-120.7-97.7-218.7-218.1-218.7z m87.8 353.4l-20 13.2-5 24.2c-1.4 6.7-3 19.2-5.5 40.1l-1.4 11.8H658.9l-1.4-13c-0.6-5.4-1.2-10.1-1.6-14.3l-1.3-11.2c-0.5-3.5-0.8-6.2-1.1-8.4l-0.3-2c-0.2-1-0.3-1.8-0.5-2.7-0.3-1.6-0.7-3.2-1.1-4.9-4.6-17.2-6.2-21.5-22.3-32.4l-2.9-2c-43.5-29.8-70-79.1-70-133 0-88.8 71.7-160.8 160-160.8s160 71.9 160 160.8c0 54.2-27.1 104.8-72.3 134.6zM698.6 491.9c-63.9 11.9-96.1 56-99.8 123.1-0.9 16 11.4 29.7 27.4 30.6 16 0.9 29.7-11.4 30.7-27.4 2.3-42.2 17.2-62.7 52.3-69.2l0.7-0.2c15.5-3.2 25.5-18.2 22.6-33.8-2.9-15.7-18-26.1-33.9-23.1z"
      fill="#246889"
      p-id="40472"
    />
    <path
      d="M710 548.8l-0.7 0.2c-35.1 6.5-50 27-52.3 69.2-0.9 16-14.6 28.3-30.7 27.4-16-0.9-28.3-14.6-27.4-30.6 3.7-67 35.9-111.2 99.8-123.1 15.9-3 31 7.4 34 23.2 2.7 15.5-7.3 30.5-22.7 33.7z"
      fill="#246889"
      p-id="40473"
    />
    <path
      d="M256.9 531.8c-18.5 0-33.5 15-33.5 33.5s15 33.4 33.5 33.4h143.8c18.5 0 33.5-15 33.5-33.4 0-18.5-15-33.5-33.5-33.5H256.9zM255.6 355.9c-17.8 0-32.2 14.4-32.2 32.2 0 17.8 14.4 32.2 32.2 32.2h228.1c17.8 0 32.2-14.4 32.2-32.2 0-17.8-14.4-32.2-32.2-32.2H255.6z"
      fill="#008FD5"
      p-id="40474"
    />
    <path
      d="M762.8 113.1h-58.5v-29c0-16.8-13.6-30.5-30.5-30.5H303.5c-16.9 0-30.5 13.6-30.5 30.5v29h-53.5c-71.7 0-129.9 61-129.9 136.3V834c0 75.3 58.2 136.3 129.9 136.3h272.8c18.5 0 33.5-15 33.5-33.5s-15-33.4-33.5-33.4H203.8c-27.1-0.5-48.9-23.7-48.9-52.4V231.6c0.4-28.5 22.6-51.5 49.8-51.5H273v46.3c0 16.8 13.6 30.5 30.5 30.5h370.2c16.9 0 30.5-13.6 30.5-30.5V180h73.4c27.1 0.4 48.9 23.7 48.9 52.4v110c0 18.2 14.8 33 33 33s33-14.8 33-33v-93.1c0.2-75.2-58-136.2-129.7-136.2z m-123 66.9c0 6.8-5.6 12.4-12.4 12.4H349.9c-6.8 0-12.4-5.6-12.4-12.4v-47.1c0-6.8 5.6-12.4 12.4-12.4h277.6c6.9 0 12.4 5.6 12.4 12.4V180z"
      fill="#008FD5"
      p-id="40475"
    />
  </svg>
</template>
